import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkExecuteAndReturnResultOrShowError } from '../../services/base.service';
import {
  getCourseCodeFormViewModel,
  getCourseCodeFormViewModelFullGradeDescriptions,
} from '../../services/common.service';
import { CourseCodeFormViewModel } from '../../types/CourseCodeFormViewModel';

export const fetchCourseCodeFormViewModel = createAsyncThunk(
  'input/fetchCourseCodeFormViewModel',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<CourseCodeFormViewModel>(
      thunkAPI,
      getCourseCodeFormViewModel({ signal: thunkAPI.signal })
    );
  }
);

export const fetchCourseCodeFormViewModelFullGradeDescriptions = createAsyncThunk(
  'input/fetchCourseCodeFormViewModel',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<CourseCodeFormViewModel>(
      thunkAPI,
      getCourseCodeFormViewModelFullGradeDescriptions({ signal: thunkAPI.signal })
    );
  }
);
